"use client";
import Link from "next/link";
import { logo } from "@assets";
import Image from "next/image";
import { Separator } from "@components/ui/separator";
import { connectionLinks, CONTACT_ADDRESS, CONTACT_CITY, CONTACT_COUNTRY, CONTACT_EMAIL, CONTACT_NO, CONTACT_PROVINCE, CONTACT_ZIP_CODE, pageLinks } from "@data";

const Footer = () => {
	return (
		<footer className="bg-primary text-primary-foreground w-full px-4 sm:px-6 lg:px-8">
			<div className="mx-auto flex w-full max-w-7xl flex-col items-center justify-center gap-4 py-6">
				<div className="flex w-full flex-col justify-between gap-8 py-4 md:flex-row">
					<div className="flex w-full flex-col gap-4">
						<Link href="/">
							<Image alt="Cognition Logo" className="h-auto w-32 lg:w-52" priority src={logo} />
						</Link>
						<p className="max-w-xs text-sm">{"Empowering learners worldwide with quality education and skill development."}</p>
					</div>
					<div className="flex w-full flex-col gap-2">
						<h4 className="font-medium">Pages</h4>
						<ul className="flex w-full flex-col gap-1">
							{pageLinks?.map(pageLink => (
								<li key={pageLink?.uuid}>
									<Link className="text-xs" href={pageLink?.href}>
										{pageLink?.label}
									</Link>
								</li>
							))}
						</ul>
					</div>
					<div className="flex w-full flex-col gap-3">
						<h4 className="font-medium">Contact Us</h4>
						<div className="flex w-full flex-col gap-3">
							<Link
								className="text-sm"
								href={`https://www.google.com/maps/place/${CONTACT_ADDRESS?.replace(" ", "+")}/${CONTACT_CITY?.replace(" ", "+")}/${CONTACT_PROVINCE?.replace(" ", "+")}/${CONTACT_COUNTRY?.replace(" ", "+")}/${CONTACT_ZIP_CODE?.replace(" ", "+")}`}
								rel="noopener noreferrer"
								target="_blank"
							>
								{`${CONTACT_ADDRESS}, ${CONTACT_CITY}, ${CONTACT_PROVINCE}, ${CONTACT_COUNTRY}, ${CONTACT_ZIP_CODE}`}
							</Link>
							<Link className="text-sm" href={`mailto:${CONTACT_EMAIL}`} rel="noopener noreferrer" target="_blank">
								{CONTACT_EMAIL}
							</Link>
							<Link className="text-sm" href={`tel:${CONTACT_NO}`} rel="noopener noreferrer" target="_blank">
								{CONTACT_NO}
							</Link>
						</div>
						<div className="flex items-center gap-4">
							{connectionLinks?.map(connectionLink => {
								const Icon = connectionLink?.icon;
								return (
									<Link href={connectionLink?.href} key={connectionLink?.uuid} rel="noopener noreferrer" target="_blank">
										<Icon className="size-5" />
									</Link>
								);
							})}
						</div>
					</div>
				</div>
				<Separator />
				<div className="text-center">
					<p className="text-sm">{`© ${new Date().getFullYear()} Cognition. All rights reserved.`}</p>
				</div>
			</div>
		</footer>
	);
};

export default Footer;
